var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.92525 0 0 4.92525 0 11C0 17.0748 4.92525 22 11 22C17.0748 22 22 17.0748 22 11C22 4.92525 17.0748 0 11 0ZM9.13642 14.6758C9.65342 13.0359 10.6324 11.0715 10.8057 10.5747C11.0559 9.85325 10.6123 9.53333 9.21067 10.7662L8.899 10.1796C10.4977 8.44067 13.7894 8.04742 12.6693 10.7415C11.9698 12.4236 11.4693 13.5593 11.1833 14.4357C10.7662 15.7126 11.8195 15.1947 12.8507 14.2423C12.991 14.4714 13.0368 14.5457 13.1771 14.8097C10.8872 16.9895 8.34533 17.182 9.13642 14.6758ZM13.4832 7.18758C12.9956 7.60283 12.2733 7.59367 11.869 7.16742C11.4648 6.74117 11.5326 6.06008 12.0193 5.64483C12.507 5.22958 13.2293 5.23967 13.6336 5.665C14.036 6.09217 13.97 6.77325 13.4832 7.18758Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.90d697545499afb8e81fff8e9d3161a7.svg";
export { ForwardRef as ReactComponent };